import { twMerge } from 'tailwind-merge'
export default function ProjectsTbfIcon({ className }: { className?: string }) {
  return (
    <svg
      className={twMerge('size-4', className)}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10C5.26512 10.0003 5.51956 10.1055 5.70703 10.293C5.8945 10.4804 5.9997 10.7349 6 11V13C5.9997 13.2651 5.8945 13.5196 5.70703 13.707C5.51956 13.8945 5.26512 13.9997 5 14H1C0.734877 13.9997 0.480439 13.8945 0.292969 13.707C0.105498 13.5196 0.000304367 13.2651 0 13V11C0.000304367 10.7349 0.105498 10.4804 0.292969 10.293C0.480439 10.1055 0.734877 10.0003 1 10H5ZM1 13H5V11H1V13Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 5H13C13.2651 5.0003 13.5196 5.1055 13.707 5.29297C13.8945 5.48044 13.9997 5.73488 14 6V8C13.9997 8.26512 13.8945 8.51956 13.707 8.70703C13.5196 8.8945 13.2651 8.9997 13 9H11.5V14H10.5V9H5C4.73488 8.9997 4.48044 8.8945 4.29297 8.70703C4.1055 8.51956 4.0003 8.26512 4 8V6C4.0003 5.73488 4.1055 5.48044 4.29297 5.29297C4.48044 5.1055 4.73488 5.0003 5 5H10.5V2.28125H11.5V5ZM5 8H13V6H5V8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C7.26512 0.000304367 7.51956 0.105498 7.70703 0.292969C7.8945 0.480439 7.9997 0.734877 8 1V3C7.9997 3.26512 7.8945 3.51956 7.70703 3.70703C7.51956 3.8945 7.26512 3.9997 7 4H1C0.734877 3.9997 0.480439 3.8945 0.292969 3.70703C0.105498 3.51956 0.000304367 3.26512 0 3V1C0.000304367 0.734877 0.105498 0.480439 0.292969 0.292969C0.480439 0.105498 0.734877 0.000304367 1 0H7ZM1 3H7V1H1V3Z"
        fill="currentColor"
      />
      <path
        d="M10.8652 0.0429688C10.9651 -0.0236412 11.1019 -0.0126521 11.1904 0.0751953L11.7295 0.610352C11.8306 0.711154 11.8306 0.875737 11.7295 0.976562L11.1738 1.52832C11.0732 1.62829 10.9102 1.62821 10.8096 1.52832L10.2764 0.998047C10.1757 0.897849 10.1747 0.734901 10.2744 0.633789L10.8252 0.0761719L10.8652 0.0429688Z"
        fill="currentColor"
      />
    </svg>
  )
}
